"use strict";
/*
 * HSComboBox
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSComboBox = /** @class */ (function (_super) {
    __extends(HSComboBox, _super);
    function HSComboBox(el, options, events) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        var _this = _super.call(this, el, options, events) || this;
        // Data parameters
        var data = el.getAttribute('data-hs-combo-box');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.gap = 5;
        _this.viewport =
            (_a = (typeof (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.viewport) === 'string'
                ? document.querySelector(concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.viewport)
                : concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.viewport)) !== null && _a !== void 0 ? _a : null;
        _this.preventVisibility = (_b = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.preventVisibility) !== null && _b !== void 0 ? _b : false;
        _this.apiUrl = (_c = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiUrl) !== null && _c !== void 0 ? _c : null;
        _this.apiDataPart = (_d = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiDataPart) !== null && _d !== void 0 ? _d : null;
        _this.apiQuery = (_e = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiQuery) !== null && _e !== void 0 ? _e : null;
        _this.apiSearchQuery = (_f = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiSearchQuery) !== null && _f !== void 0 ? _f : null;
        _this.apiHeaders = (_g = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiHeaders) !== null && _g !== void 0 ? _g : {};
        _this.apiGroupField = (_h = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.apiGroupField) !== null && _h !== void 0 ? _h : null;
        _this.outputItemTemplate =
            (_j = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.outputItemTemplate) !== null && _j !== void 0 ? _j : "<div class=\"cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800\" data-hs-combo-box-output-item>\n\t\t\t\t<div class=\"flex justify-between items-center w-full\">\n\t\t\t\t\t<span data-hs-combo-box-search-text></span>\n\t\t\t\t\t<span class=\"hidden hs-combo-box-selected:block\">\n\t\t\t\t\t\t<svg class=\"shrink-0 size-3.5 text-blue-600 dark:text-blue-500\" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t\t\t\t\t\t\t<polyline points=\"20 6 9 17 4 12\"></polyline>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>";
        _this.outputEmptyTemplate =
            (_k = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.outputEmptyTemplate) !== null && _k !== void 0 ? _k : "<div class=\"py-2 px-4 w-full text-sm text-gray-800 rounded-lg dark:bg-neutral-900 dark:text-neutral-200\">Nothing found...</div>";
        _this.outputLoaderTemplate =
            (_l = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.outputLoaderTemplate) !== null && _l !== void 0 ? _l : "<div class=\"flex justify-center items-center py-2 px-4 text-sm text-gray-800 rounded-lg bg-white dark:bg-neutral-900 dark:text-neutral-200\">\n\t\t\t\t<div class=\"animate-spin inline-block size-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full dark:text-blue-500\" role=\"status\" aria-label=\"loading\">\n\t\t\t\t\t<span class=\"sr-only\">Loading...</span>\n\t\t\t\t</div>\n\t\t\t</div>";
        _this.groupingType = (_m = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.groupingType) !== null && _m !== void 0 ? _m : null;
        _this.groupingTitleTemplate =
            (_o = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.groupingTitleTemplate) !== null && _o !== void 0 ? _o : (_this.groupingType === 'default'
                ? "<div class=\"block mb-1 text-xs font-semibold uppercase text-blue-600 dark:text-blue-500\"></div>"
                : "<button type=\"button\" class=\"py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold whitespace-nowrap rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none\"></button>");
        _this.tabsWrapperTemplate =
            (_p = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.tabsWrapperTemplate) !== null && _p !== void 0 ? _p : "<div class=\"overflow-x-auto p-4\"></div>";
        _this.preventSelection = (_q = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.preventSelection) !== null && _q !== void 0 ? _q : false;
        _this.preventAutoPosition = (_r = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.preventAutoPosition) !== null && _r !== void 0 ? _r : false;
        _this.isOpenOnFocus = (_s = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isOpenOnFocus) !== null && _s !== void 0 ? _s : false;
        // Internal parameters
        _this.input = (_t = _this.el.querySelector('[data-hs-combo-box-input]')) !== null && _t !== void 0 ? _t : null;
        _this.output = (_u = _this.el.querySelector('[data-hs-combo-box-output]')) !== null && _u !== void 0 ? _u : null;
        _this.itemsWrapper =
            (_v = _this.el.querySelector('[data-hs-combo-box-output-items-wrapper]')) !== null && _v !== void 0 ? _v : null;
        _this.items =
            (_w = Array.from(_this.el.querySelectorAll('[data-hs-combo-box-output-item]'))) !== null && _w !== void 0 ? _w : [];
        _this.tabs = [];
        _this.toggle = (_x = _this.el.querySelector('[data-hs-combo-box-toggle]')) !== null && _x !== void 0 ? _x : null;
        _this.toggleClose =
            (_y = _this.el.querySelector('[data-hs-combo-box-close]')) !== null && _y !== void 0 ? _y : null;
        _this.toggleOpen = (_z = _this.el.querySelector('[data-hs-combo-box-open]')) !== null && _z !== void 0 ? _z : null;
        _this.outputPlaceholder = null;
        _this.selected = _this.value =
            (_0 = _this.el.querySelector('[data-hs-combo-box-input]')
                .value) !== null && _0 !== void 0 ? _0 : '';
        _this.isOpened = false;
        _this.isCurrent = false;
        _this.animationInProcess = false;
        _this.selectedGroup = 'all';
        _this.init();
        return _this;
    }
    HSComboBox.prototype.init = function () {
        this.createCollection(window.$hsComboBoxCollection, this);
        this.build();
    };
    HSComboBox.prototype.build = function () {
        this.buildInput();
        if (this.groupingType)
            this.setGroups();
        this.buildItems();
        if (this.preventVisibility) {
            // TODO:: test the plugin while the line below is commented.
            // this.isOpened = true;
            if (!this.preventAutoPosition)
                this.recalculateDirection();
        }
        if (this.toggle)
            this.buildToggle();
        if (this.toggleClose)
            this.buildToggleClose();
        if (this.toggleOpen)
            this.buildToggleOpen();
    };
    HSComboBox.prototype.setResultAndRender = function (value) {
        if (value === void 0) { value = ''; }
        // TODO:: test the plugin with below code added.
        var _value = this.preventVisibility ? this.input.value : value;
        this.setResults(_value);
        if (this.apiSearchQuery)
            this.itemsFromJson();
    };
    HSComboBox.prototype.buildInput = function () {
        var _this = this;
        if (this.isOpenOnFocus) {
            this.input.addEventListener('focus', function () {
                if (!_this.isOpened) {
                    _this.setResultAndRender();
                    _this.open();
                }
            });
        }
        this.input.addEventListener('input', (0, utils_1.debounce)(function (evt) {
            _this.setResultAndRender(evt.target.value);
            if (_this.input.value !== '')
                _this.el.classList.add('has-value');
            else
                _this.el.classList.remove('has-value');
            if (!_this.isOpened)
                _this.open();
        }));
    };
    HSComboBox.prototype.buildItems = function () {
        this.output.role = 'listbox';
        this.output.tabIndex = -1;
        this.output.ariaOrientation = 'vertical';
        if (this.apiUrl)
            this.itemsFromJson();
        else {
            if (this.itemsWrapper)
                this.itemsWrapper.innerHTML = '';
            else
                this.output.innerHTML = '';
            this.itemsFromHtml();
        }
    };
    HSComboBox.prototype.setResults = function (val) {
        this.value = val;
        this.resultItems();
        if (this.hasVisibleItems())
            this.destroyOutputPlaceholder();
        else
            this.buildOutputPlaceholder();
    };
    HSComboBox.prototype.isItemExists = function (obj) {
        return this.items.some(function (el) {
            var _a, _b, _c;
            var groupField = (_a = el.getAttribute('data-hs-combo-box-output-item-group-field')) !== null && _a !== void 0 ? _a : null;
            var params = (_b = JSON.parse(el.getAttribute('data-hs-combo-box-output-item'))) !== null && _b !== void 0 ? _b : null;
            var group = null;
            if (groupField && ((_c = params === null || params === void 0 ? void 0 : params.group) === null || _c === void 0 ? void 0 : _c.name))
                group = obj[groupField];
            return Array.from(el.querySelectorAll('[data-hs-combo-box-search-text]')).some(function (elI) {
                var _a;
                var equality = ((_a = params === null || params === void 0 ? void 0 : params.group) === null || _a === void 0 ? void 0 : _a.name) && group
                    ? group === params.group.name &&
                        elI.getAttribute('data-hs-combo-box-search-text') ===
                            obj[elI.getAttribute('data-hs-combo-box-output-item-field')]
                    : elI.getAttribute('data-hs-combo-box-search-text') ===
                        obj[elI.getAttribute('data-hs-combo-box-output-item-field')];
                return equality;
            });
        });
    };
    HSComboBox.prototype.isTextExists = function (el, val) {
        var lowerCased = val.map(function (v) { return v.toLowerCase(); });
        return Array.from(el.querySelectorAll('[data-hs-combo-box-search-text]')).some(function (elI) {
            return lowerCased.includes(elI.getAttribute('data-hs-combo-box-search-text').toLowerCase());
        });
    };
    HSComboBox.prototype.isTextExistsAny = function (el, val) {
        return Array.from(el.querySelectorAll('[data-hs-combo-box-search-text]')).some(function (elI) {
            return elI
                .getAttribute('data-hs-combo-box-search-text')
                .toLowerCase()
                .includes(val.toLowerCase());
        });
    };
    HSComboBox.prototype.valuesBySelector = function (el) {
        return Array.from(el.querySelectorAll('[data-hs-combo-box-search-text]')).reduce(function (acc, cur) { return __spreadArray(__spreadArray([], acc, true), [
            cur.getAttribute('data-hs-combo-box-search-text'),
        ], false); }, []);
    };
    HSComboBox.prototype.buildOutputLoader = function () {
        if (this.outputLoader)
            return false;
        this.outputLoader = (0, utils_1.htmlToElement)(this.outputLoaderTemplate);
        if (this.items.length || this.outputPlaceholder) {
            this.outputLoader.style.position = 'absolute';
            this.outputLoader.style.top = '0';
            this.outputLoader.style.bottom = '0';
            this.outputLoader.style.left = '0';
            this.outputLoader.style.right = '0';
            this.outputLoader.style.zIndex = '2';
        }
        else {
            this.outputLoader.style.position = '';
            this.outputLoader.style.top = '';
            this.outputLoader.style.bottom = '';
            this.outputLoader.style.left = '';
            this.outputLoader.style.right = '';
            this.outputLoader.style.zIndex = '';
            this.outputLoader.style.height = '30px';
        }
        this.output.append(this.outputLoader);
    };
    HSComboBox.prototype.destroyOutputLoader = function () {
        if (this.outputLoader)
            this.outputLoader.remove();
        this.outputLoader = null;
    };
    HSComboBox.prototype.itemsFromJson = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, searchQuery, url, res, items_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.buildOutputLoader();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        query = "".concat(this.apiQuery);
                        searchQuery = "".concat(this.apiSearchQuery, "=").concat(this.value.toLowerCase());
                        url = this.apiUrl;
                        if (this.apiQuery && this.apiSearchQuery) {
                            url += "?".concat(searchQuery, "&").concat(query);
                        }
                        else if (this.apiQuery) {
                            url += "?".concat(query);
                        }
                        else if (this.apiSearchQuery) {
                            url += "?".concat(searchQuery);
                        }
                        return [4 /*yield*/, fetch(url, this.apiHeaders)];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 3:
                        items_1 = _a.sent();
                        if (this.apiDataPart) {
                            items_1 = items_1[this.apiDataPart];
                        }
                        if (this.apiSearchQuery) {
                            this.items = [];
                        }
                        if (this.itemsWrapper) {
                            this.itemsWrapper.innerHTML = '';
                        }
                        else {
                            this.output.innerHTML = '';
                        }
                        if (this.groupingType === 'tabs') {
                            this.setApiGroups(items_1);
                            this.groupTabsRender();
                            this.jsonItemsRender(items_1);
                        }
                        else if (this.groupingType === 'default') {
                            this.setApiGroups(items_1);
                            this.groups.forEach(function (el) {
                                var title = (0, utils_1.htmlToElement)(_this.groupingTitleTemplate);
                                title.setAttribute('data-hs-combo-box-group-title', el.name);
                                title.classList.add('--exclude-accessibility');
                                title.innerText = el.title;
                                var newItems = items_1.filter(function (i) { return i[_this.apiGroupField] === el.name; });
                                if (_this.itemsWrapper)
                                    _this.itemsWrapper.append(title);
                                else
                                    _this.output.append(title);
                                _this.jsonItemsRender(newItems);
                            });
                        }
                        else {
                            this.jsonItemsRender(items_1);
                        }
                        this.setResults(this.input.value);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.destroyOutputLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    HSComboBox.prototype.jsonItemsRender = function (items) {
        var _this = this;
        items.forEach(function (item, index) {
            // TODO:: test without checking below
            // if (this.isItemExists(item)) return false;
            var newItem = (0, utils_1.htmlToElement)(_this.outputItemTemplate);
            newItem
                .querySelectorAll('[data-hs-combo-box-output-item-field]')
                .forEach(function (el) {
                var value = item[el.getAttribute('data-hs-combo-box-output-item-field')];
                var hideIfEmpty = el.hasAttribute('data-hs-combo-box-output-item-hide-if-empty');
                el.textContent = value !== null && value !== void 0 ? value : '';
                if (!value && hideIfEmpty)
                    el.style.display = 'none';
            });
            newItem
                .querySelectorAll('[data-hs-combo-box-search-text]')
                .forEach(function (el) {
                var _a;
                el.setAttribute('data-hs-combo-box-search-text', (_a = item[el.getAttribute('data-hs-combo-box-output-item-field')]) !== null && _a !== void 0 ? _a : '');
            });
            newItem
                .querySelectorAll('[data-hs-combo-box-output-item-attr]')
                .forEach(function (el) {
                var attributes = JSON.parse(el.getAttribute('data-hs-combo-box-output-item-attr'));
                attributes.forEach(function (attr) {
                    el.setAttribute(attr.attr, item[attr.valueFrom]);
                });
            });
            newItem.setAttribute('tabIndex', "".concat(index));
            if (_this.groupingType === 'tabs' || _this.groupingType === 'default') {
                newItem.setAttribute('data-hs-combo-box-output-item', "{\"group\": {\"name\": \"".concat(item[_this.apiGroupField], "\", \"title\": \"").concat(item[_this.apiGroupField], "\"}}"));
            }
            _this.items = __spreadArray(__spreadArray([], _this.items, true), [newItem], false);
            if (!_this.preventSelection) {
                newItem.addEventListener('click', function () {
                    _this.close(newItem
                        .querySelector('[data-hs-combo-box-value]')
                        .getAttribute('data-hs-combo-box-search-text'));
                    _this.setSelectedByValue(_this.valuesBySelector(newItem));
                });
            }
            _this.appendItemsToWrapper(newItem);
        });
    };
    HSComboBox.prototype.setGroups = function () {
        var groups = [];
        this.items.forEach(function (item) {
            var group = JSON.parse(item.getAttribute('data-hs-combo-box-output-item')).group;
            if (!groups.some(function (el) { return (el === null || el === void 0 ? void 0 : el.name) === group.name; })) {
                groups.push(group);
            }
        });
        this.groups = groups;
    };
    HSComboBox.prototype.setCurrent = function () {
        if (window.$hsComboBoxCollection.length) {
            window.$hsComboBoxCollection.map(function (el) { return (el.element.isCurrent = false); });
            this.isCurrent = true;
        }
    };
    HSComboBox.prototype.setApiGroups = function (items) {
        var _this = this;
        var groups = [];
        items.forEach(function (item) {
            var group = item[_this.apiGroupField];
            if (!groups.some(function (el) { return el.name === group; })) {
                groups.push({
                    name: group,
                    title: group,
                });
            }
        });
        this.groups = groups;
    };
    HSComboBox.prototype.sortItems = function () {
        var compareFn = function (i1, i2) {
            var a = i1
                .querySelector('[data-hs-combo-box-value]')
                .getAttribute('data-hs-combo-box-search-text');
            var b = i2
                .querySelector('[data-hs-combo-box-value]')
                .getAttribute('data-hs-combo-box-search-text');
            if (a < b) {
                return -1;
            }
            else if (a > b) {
                return 1;
            }
            return 0;
        };
        return this.items.sort(compareFn);
    };
    HSComboBox.prototype.itemRender = function (item) {
        var _this = this;
        var val = item
            .querySelector('[data-hs-combo-box-value]')
            .getAttribute('data-hs-combo-box-search-text');
        if (this.itemsWrapper)
            this.itemsWrapper.append(item);
        else
            this.output.append(item);
        if (!this.preventSelection) {
            item.addEventListener('click', function () {
                _this.close(val);
                _this.setSelectedByValue(_this.valuesBySelector(item));
            });
        }
    };
    HSComboBox.prototype.plainRender = function (items) {
        var _this = this;
        items.forEach(function (item) {
            _this.itemRender(item);
        });
    };
    HSComboBox.prototype.groupTabsRender = function () {
        var _this = this;
        var tabsScroll = (0, utils_1.htmlToElement)(this.tabsWrapperTemplate);
        var tabsWrapper = (0, utils_1.htmlToElement)("<div class=\"flex flex-nowrap gap-x-2\"></div>");
        tabsScroll.append(tabsWrapper);
        this.output.insertBefore(tabsScroll, this.output.firstChild);
        var tabDef = (0, utils_1.htmlToElement)(this.groupingTitleTemplate);
        tabDef.setAttribute('data-hs-combo-box-group-title', 'all');
        tabDef.classList.add('--exclude-accessibility', 'active');
        tabDef.innerText = 'All';
        this.tabs = __spreadArray(__spreadArray([], this.tabs, true), [tabDef], false);
        tabsWrapper.append(tabDef);
        tabDef.addEventListener('click', function () {
            _this.selectedGroup = 'all';
            var selectedTab = _this.tabs.find(function (elI) {
                return elI.getAttribute('data-hs-combo-box-group-title') ===
                    _this.selectedGroup;
            });
            _this.tabs.forEach(function (el) { return el.classList.remove('active'); });
            selectedTab.classList.add('active');
            _this.setItemsVisibility();
        });
        this.groups.forEach(function (el) {
            var tab = (0, utils_1.htmlToElement)(_this.groupingTitleTemplate);
            tab.setAttribute('data-hs-combo-box-group-title', el.name);
            tab.classList.add('--exclude-accessibility');
            tab.innerText = el.title;
            _this.tabs = __spreadArray(__spreadArray([], _this.tabs, true), [tab], false);
            tabsWrapper.append(tab);
            tab.addEventListener('click', function () {
                _this.selectedGroup = el.name;
                var selectedTab = _this.tabs.find(function (elI) {
                    return elI.getAttribute('data-hs-combo-box-group-title') ===
                        _this.selectedGroup;
                });
                _this.tabs.forEach(function (el) { return el.classList.remove('active'); });
                selectedTab.classList.add('active');
                _this.setItemsVisibility();
            });
        });
    };
    HSComboBox.prototype.groupDefaultRender = function () {
        var _this = this;
        this.groups.forEach(function (el) {
            var title = (0, utils_1.htmlToElement)(_this.groupingTitleTemplate);
            title.setAttribute('data-hs-combo-box-group-title', el.name);
            title.classList.add('--exclude-accessibility');
            title.innerText = el.title;
            if (_this.itemsWrapper)
                _this.itemsWrapper.append(title);
            else
                _this.output.append(title);
            var items = _this.sortItems().filter(function (f) {
                var group = JSON.parse(f.getAttribute('data-hs-combo-box-output-item')).group;
                return group.name === el.name;
            });
            _this.plainRender(items);
        });
    };
    HSComboBox.prototype.itemsFromHtml = function () {
        if (this.groupingType === 'default') {
            this.groupDefaultRender();
        }
        else if (this.groupingType === 'tabs') {
            var items = this.sortItems();
            this.groupTabsRender();
            this.plainRender(items);
        }
        else {
            var items = this.sortItems();
            this.plainRender(items);
        }
        this.setResults(this.input.value);
    };
    HSComboBox.prototype.buildToggle = function () {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.isOpened) {
            if ((_a = this === null || this === void 0 ? void 0 : this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
                this.toggle.ariaExpanded = 'true';
            if ((_b = this === null || this === void 0 ? void 0 : this.input) === null || _b === void 0 ? void 0 : _b.ariaExpanded)
                this.input.ariaExpanded = 'true';
        }
        else {
            if ((_c = this === null || this === void 0 ? void 0 : this.toggle) === null || _c === void 0 ? void 0 : _c.ariaExpanded)
                this.toggle.ariaExpanded = 'false';
            if ((_d = this === null || this === void 0 ? void 0 : this.input) === null || _d === void 0 ? void 0 : _d.ariaExpanded)
                this.input.ariaExpanded = 'false';
        }
        this.toggle.addEventListener('click', function () {
            if (_this.isOpened)
                _this.close();
            else
                _this.open(_this.toggle.getAttribute('data-hs-combo-box-toggle'));
        });
    };
    HSComboBox.prototype.buildToggleClose = function () {
        var _this = this;
        this.toggleClose.addEventListener('click', function () { return _this.close(); });
    };
    HSComboBox.prototype.buildToggleOpen = function () {
        var _this = this;
        this.toggleOpen.addEventListener('click', function () { return _this.open(); });
    };
    HSComboBox.prototype.setSelectedByValue = function (val) {
        var _this = this;
        this.items.forEach(function (el) {
            if (_this.isTextExists(el, val))
                el.classList.add('selected');
            else
                el.classList.remove('selected');
        });
    };
    HSComboBox.prototype.setValue = function (val) {
        this.selected = val;
        this.value = val;
        this.input.value = val;
        this.fireEvent('select', this.el);
        (0, utils_1.dispatch)('select.hs.combobox', this.el, this.value);
    };
    HSComboBox.prototype.setItemsVisibility = function () {
        var _this = this;
        if (this.groupingType === 'tabs' && this.selectedGroup !== 'all') {
            this.items.forEach(function (item) {
                item.style.display = 'none';
            });
        }
        var items = this.groupingType === 'tabs'
            ? this.selectedGroup === 'all'
                ? this.items
                : this.items.filter(function (f) {
                    var group = JSON.parse(f.getAttribute('data-hs-combo-box-output-item')).group;
                    return group.name === _this.selectedGroup;
                })
            : this.items;
        if (this.groupingType === 'tabs' && this.selectedGroup !== 'all') {
            items.forEach(function (item) {
                item.style.display = 'block';
            });
        }
        items.forEach(function (item) {
            if (!_this.isTextExistsAny(item, _this.value))
                item.style.display = 'none';
            else
                item.style.display = 'block';
        });
        if (this.groupingType === 'default') {
            this.output
                .querySelectorAll('[data-hs-combo-box-group-title]')
                .forEach(function (el) {
                var g = el.getAttribute('data-hs-combo-box-group-title');
                var items = _this.items.filter(function (f) {
                    var group = JSON.parse(f.getAttribute('data-hs-combo-box-output-item')).group;
                    return group.name === g && f.style.display === 'block';
                });
                if (items.length)
                    el.style.display = 'block';
                else
                    el.style.display = 'none';
            });
        }
    };
    HSComboBox.prototype.hasVisibleItems = function () {
        return this.items.length
            ? this.items.some(function (el) { return el.style.display === 'block'; })
            : false;
    };
    HSComboBox.prototype.appendItemsToWrapper = function (item) {
        if (this.itemsWrapper) {
            this.itemsWrapper.append(item);
        }
        else {
            this.output.append(item);
        }
    };
    HSComboBox.prototype.buildOutputPlaceholder = function () {
        if (!this.outputPlaceholder)
            this.outputPlaceholder = (0, utils_1.htmlToElement)(this.outputEmptyTemplate);
        this.appendItemsToWrapper(this.outputPlaceholder);
    };
    HSComboBox.prototype.destroyOutputPlaceholder = function () {
        if (this.outputPlaceholder)
            this.outputPlaceholder.remove();
        this.outputPlaceholder = null;
    };
    HSComboBox.prototype.resultItems = function () {
        if (!this.items.length)
            return false;
        this.setItemsVisibility();
        this.setSelectedByValue([this.selected]);
    };
    // Public methods
    HSComboBox.prototype.setValueAndOpen = function (val) {
        this.value = val;
        if (this.items.length) {
            this.setItemsVisibility();
        }
    };
    HSComboBox.prototype.open = function (val) {
        var _this = this;
        if (this.animationInProcess)
            return false;
        if (typeof val !== 'undefined')
            this.setValueAndOpen(val);
        if (this.preventVisibility)
            return false;
        this.animationInProcess = true;
        this.output.style.display = 'block';
        if (!this.preventAutoPosition)
            this.recalculateDirection();
        setTimeout(function () {
            var _a, _b;
            if ((_a = _this === null || _this === void 0 ? void 0 : _this.input) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
                _this.input.ariaExpanded = 'true';
            if ((_b = _this === null || _this === void 0 ? void 0 : _this.toggle) === null || _b === void 0 ? void 0 : _b.ariaExpanded)
                _this.toggle.ariaExpanded = 'true';
            _this.el.classList.add('active');
            _this.animationInProcess = false;
        });
        this.isOpened = true;
    };
    HSComboBox.prototype.setValueAndClear = function (val) {
        if (val)
            this.setValue(val);
        else
            this.setValue(this.selected);
        if (this.outputPlaceholder)
            this.destroyOutputPlaceholder();
    };
    HSComboBox.prototype.close = function (val) {
        var _this = this;
        var _a, _b;
        if (this.animationInProcess)
            return false;
        if (this.preventVisibility) {
            this.setValueAndClear(val);
            if (this.input.value !== '')
                this.el.classList.add('has-value');
            else
                this.el.classList.remove('has-value');
            return false;
        }
        this.animationInProcess = true;
        if ((_a = this === null || this === void 0 ? void 0 : this.input) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
            this.input.ariaExpanded = 'false';
        if ((_b = this === null || this === void 0 ? void 0 : this.toggle) === null || _b === void 0 ? void 0 : _b.ariaExpanded)
            this.toggle.ariaExpanded = 'false';
        this.el.classList.remove('active');
        if (!this.preventAutoPosition) {
            this.output.classList.remove('bottom-full', 'top-full');
            this.output.style.marginTop = '';
            this.output.style.marginBottom = '';
        }
        (0, utils_1.afterTransition)(this.output, function () {
            _this.output.style.display = 'none';
            _this.setValueAndClear(val);
            _this.animationInProcess = false;
        });
        if (this.input.value !== '')
            this.el.classList.add('has-value');
        else
            this.el.classList.remove('has-value');
        this.isOpened = false;
    };
    HSComboBox.prototype.recalculateDirection = function () {
        if ((0, utils_1.isEnoughSpace)(this.output, this.input, 'bottom', this.gap, this.viewport)) {
            this.output.classList.remove('bottom-full');
            this.output.style.marginBottom = '';
            this.output.classList.add('top-full');
            this.output.style.marginTop = "".concat(this.gap, "px");
        }
        else {
            this.output.classList.remove('top-full');
            this.output.style.marginTop = '';
            this.output.classList.add('bottom-full');
            this.output.style.marginBottom = "".concat(this.gap, "px");
        }
    };
    // Static methods
    HSComboBox.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsComboBoxCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSComboBox.autoInit = function () {
        if (!window.$hsComboBoxCollection)
            window.$hsComboBoxCollection = [];
        document
            .querySelectorAll('[data-hs-combo-box]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsComboBoxCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; })) {
                var data = el.getAttribute('data-hs-combo-box');
                var options = data ? JSON.parse(data) : {};
                new HSComboBox(el, options);
            }
        });
        if (window.$hsComboBoxCollection) {
            window.addEventListener('click', function (evt) {
                var evtTarget = evt.target;
                HSComboBox.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener('keydown', function (evt) {
                return HSComboBox.accessibility(evt);
            });
        }
    };
    HSComboBox.close = function (target) {
        var elInCollection = window.$hsComboBoxCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection && elInCollection.element.isOpened) {
            elInCollection.element.close();
        }
    };
    HSComboBox.closeCurrentlyOpened = function (evtTarget) {
        if (evtTarget === void 0) { evtTarget = null; }
        if (!evtTarget.closest('[data-hs-combo-box].active')) {
            var currentlyOpened = window.$hsComboBoxCollection.filter(function (el) { return el.element.isOpened; }) ||
                null;
            if (currentlyOpened) {
                currentlyOpened.forEach(function (el) {
                    el.element.close();
                });
            }
        }
    };
    // Accessibility methods
    HSComboBox.getPreparedItems = function (isReversed, output) {
        if (isReversed === void 0) { isReversed = false; }
        if (!output)
            return null;
        var preparedItems = isReversed
            ? Array.from(output.querySelectorAll(':scope > *:not(.--exclude-accessibility)'))
                .filter(function (el) { return el.style.display !== 'none'; })
                .reverse()
            : Array.from(output.querySelectorAll(':scope > *:not(.--exclude-accessibility)')).filter(function (el) { return el.style.display !== 'none'; });
        var items = preparedItems.filter(function (el) { return !el.classList.contains('disabled'); });
        return items;
    };
    HSComboBox.setHighlighted = function (prev, current, input) {
        current.focus();
        input.value = current
            .querySelector('[data-hs-combo-box-value]')
            .getAttribute('data-hs-combo-box-search-text');
        if (prev)
            prev.classList.remove('hs-combo-box-output-item-highlighted');
        current.classList.add('hs-combo-box-output-item-highlighted');
    };
    HSComboBox.accessibility = function (evt) {
        var target = window.$hsComboBoxCollection.find(function (el) {
            return el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened;
        });
        if (target &&
            constants_1.COMBO_BOX_ACCESSIBILITY_KEY_SET.includes(evt.code) &&
            !evt.metaKey) {
            switch (evt.code) {
                case 'Escape':
                    evt.preventDefault();
                    this.onEscape();
                    break;
                case 'ArrowUp':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow();
                    break;
                case 'ArrowDown':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow(false);
                    break;
                case 'Home':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd();
                    break;
                case 'End':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd(false);
                    break;
                case 'Enter':
                    evt.preventDefault();
                    this.onEnter(evt);
                    break;
                default:
                    break;
            }
        }
    };
    HSComboBox.onEscape = function () {
        var target = window.$hsComboBoxCollection.find(function (el) { return !el.element.preventVisibility && el.element.isOpened; });
        if (target) {
            target.element.close();
            target.element.input.blur();
        }
    };
    HSComboBox.onArrow = function (isArrowUp) {
        var _a;
        if (isArrowUp === void 0) { isArrowUp = true; }
        var target = window.$hsComboBoxCollection.find(function (el) {
            return el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened;
        });
        if (target) {
            var output = (_a = target.element.itemsWrapper) !== null && _a !== void 0 ? _a : target.element.output;
            if (!output)
                return false;
            var items = HSComboBox.getPreparedItems(isArrowUp, output);
            var current_1 = output.querySelector('.hs-combo-box-output-item-highlighted');
            var currentItem = null;
            if (!current_1)
                items[0].classList.add('hs-combo-box-output-item-highlighted');
            var currentInd = items.findIndex(function (el) { return el === current_1; });
            if (currentInd + 1 < items.length)
                currentInd++;
            currentItem = items[currentInd];
            HSComboBox.setHighlighted(current_1, currentItem, target.element.input);
        }
    };
    HSComboBox.onStartEnd = function (isStart) {
        var _a;
        if (isStart === void 0) { isStart = true; }
        var target = window.$hsComboBoxCollection.find(function (el) {
            return el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened;
        });
        if (target) {
            var output = (_a = target.element.itemsWrapper) !== null && _a !== void 0 ? _a : target.element.output;
            if (!output)
                return false;
            var items = HSComboBox.getPreparedItems(isStart, output);
            var current = output.querySelector('.hs-combo-box-output-item-highlighted');
            if (items.length)
                HSComboBox.setHighlighted(current, items[0], target.element.input);
        }
    };
    HSComboBox.onEnter = function (evt) {
        var target = evt.target;
        var opened = window.$hsComboBoxCollection.find(function (el) {
            return !(0, utils_1.isParentOrElementHidden)(el.element.el) &&
                evt.target.closest('[data-hs-combo-box]') ===
                    el.element.el;
        });
        var link = opened.element.el.querySelector('.hs-combo-box-output-item-highlighted a');
        if (target.hasAttribute('data-hs-combo-box-input')) {
            opened.element.close();
            target.blur();
        }
        else {
            if (!opened.element.preventSelection) {
                opened.element.setSelectedByValue(opened.element.valuesBySelector(evt.target));
            }
            if (opened.element.preventSelection && link) {
                window.location.assign(link.getAttribute('href'));
            }
            opened.element.close(!opened.element.preventSelection
                ? evt.target
                    .querySelector('[data-hs-combo-box-value]')
                    .getAttribute('data-hs-combo-box-search-text')
                : null);
        }
    };
    return HSComboBox;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSComboBox.autoInit();
    // Uncomment for debug
    // console.log('ComboBox collection:', window.$hsComboBoxCollection);
});
document.addEventListener('scroll', function () {
    if (!window.$hsComboBoxCollection)
        return false;
    var target = window.$hsComboBoxCollection.find(function (el) { return el.element.isOpened; });
    if (target && !target.element.preventAutoPosition)
        target.element.recalculateDirection();
});
if (typeof window !== 'undefined') {
    window.HSComboBox = HSComboBox;
}
exports.default = HSComboBox;
